import { BaseIp, ProIp } from "./ApiURL";


//getMapping
export const getInstituteAPI = ProIp + "institute/getInstitute"
//institute/getInstitute